export default __webpack_public_path__ + "static/media/mirloAcuático.a270cddf.jpg";